import Vue from 'vue'
import Router from 'vue-router'

import store from '@/store'
import account from '@/store/account'
const STATE = store.state

import { includes, get, isEmpty, isNil, map } from 'lodash'

//routes
import dashboard from './dashboard'
import onBoarding from './onBoarding'
import builder from './builder'
import monitoring from './monitoring'
import settings from './settings'
import marketPlace from './marketPlace'
import businessApps from './businessApps'
import forbidden from './forbidden'

//components
import PageNotFound from '../views/PageNotFound.vue'

Vue.use(Router)
const router = new Router({
    mode: 'history',
    linkActiveClass: 'link-is-active',
    linkExactActiveClass: '',
    base: '/',
    routes: [
        ...onBoarding,
        ...dashboard,
        ...builder,
        monitoring,
        settings,
        marketPlace,
        businessApps,
        forbidden,
        {
            path: '*',
            component: PageNotFound
        }
    ].map(r => {
        return {
            ...r,
            meta: {
                requiresAuth: true
            }
        }
    })
})

function checkRights(to, from, next) {
    let isAuthenticated = false
    let resolve = true
    if (to.name === 'builder-segment') {
        isAuthenticated = store.getters['account/getAccessToBuilderSegment']()
        //Redirect in case of missing right
        if (!isAuthenticated) {
            next({ name: 'monitoring', params: to.params })
            resolve = false
        }
    }

    if (to.name.includes('monitoring')) {
        isAuthenticated = store.getters['account/getAccessToMonitoring']()
        //Redirect in case of missing right
        if (!isAuthenticated) {
            next({ name: 'on-boarding-cclone', params: to.params })
            resolve = false
        }
    }
    if (to.name === 'on-boarding-cclone') {
        isAuthenticated = store.getters['account/getAccessToCclone']()
        //Redirect in case of missing right
        if (!isAuthenticated) {
            next({ name: 'on-boarding-manage-taxonomy', params: to.params })
            resolve = false
        }
    }
    if (to.name === 'allocation' || to.name === 'alerts') {
        isAuthenticated = store.state.account.settings.allocationDashboardActivated && store.getters['account/getReadAlertsAllowed']()
    }
    if (to.name === 'account') {
        isAuthenticated = true
    }
    if (to.name === 'on-boarding-manage-taxonomy') {
        isAuthenticated = store.getters['account/getAccessToManageTaxo']()
    }
    if (to.name === 'on-boarding-manage-data-entry') {
        isAuthenticated = store.getters['account/getAccessToDEM']()
    }
    if (to.name === 'partners') {
        isAuthenticated = store.getters['account/getAccessToDSP']()
    }
    if (to.name === 'georadar') {
        isAuthenticated = store.getters['account/getAccessToGeoradar']()
    }
    if (to.name === 'settings') {
        isAuthenticated = store.getters['account/getAccessToSettings']()
    }
    if (to.name === 'builder-cclone') {
        isAuthenticated = store.getters['account/getAccessToCclone']()
    }
    if (to.name === 'MarketPlaceWrapper') {
        isAuthenticated = store.state.account.userRole === 'webo_admin'
        // Shall be put back once the Marketplace page is ready
        // isAuthenticated = true
    }
    if (to.name === 'businessApps') {
        isAuthenticated = true
    }
    if (to.name === 'forbidden') {
        isAuthenticated = true
    }
    if (!isAuthenticated && resolve) {
        store.commit(
            'notifications/setAddedNotification',
            {
                type: 'warning',
                message: 'you are not allowed to access to this resource'
            },
            { root: true }
        )
        next({ name: 'forbidden', params: to.params })
    } else {
        router.app.$keycloak.updateTokenBeforeRoute(to, from, next)
    }
}

router.beforeEach((to, from, next) => {
    //Redirect to portal if no account is given
    if (!to.params.account_id) {
        window.location.href = process.env.VUE_APP_PORTAL_URL
    }

    if (to.name === 'settings') {
        if (!isNil(from.name)) {
            store.commit('ui/settings/setPreviousRoute', { route: from.path }, { root: true })
        }
    }
    if (account.state.userRole === null) {
        store.commit('account/setUserRole', { roles: get(Vue.prototype.$keycloak, 'tokenParsed.realm_access.roles', 'unknown') }, { root: true })
        store.dispatch('account/retrieveAccountId', { accountId: to.params.account_id }, { root: true }).then(() => {
            //Redirect to portal when account is inactive
            if (account.state.userRole === 'webo_user') {
                store.dispatch('account/retrieveUserRights', {}, { root: true }).then(response => {
                    if (response === 'success') {
                        store.commit('account/setIsAccountAllowed', { allowed: true }, { root: true })
                        store.dispatch('account/retrieveItems', {}, { root: true }).then(() => {
                            if (!store.getters['account/getAccessToAccount']()) {
                                window.location.href = process.env.VUE_APP_PORTAL_URL
                            }
                            checkRights(to, from, next)
                        })
                    } else {
                        window.location.href = process.env.VUE_APP_PORTAL_URL
                    }
                })
            } else if (['webo_employee', 'webo_admin'].includes(account.state.userRole)) {
                store.commit('account/setIsAccountAllowed', { allowed: true }, { root: true })
                store.dispatch('account/retrieveItems', {}, { root: true }).then(() => {
                    if (!store.getters['account/getAccessToAccount']()) {
                        window.location.href = process.env.VUE_APP_PORTAL_URL
                    }
                    checkRights(to, from, next)
                })
            } else {
                store.commit('account/setIsAccountAllowed', { allowed: false }, { root: true })
                store.commit(
                    'notifications/setAddedNotification',
                    {
                        type: 'error',
                        message: 'User ' + get(Vue.prototype.$keycloak, 'tokenParsed.email', '') + ' has no access on account ' + to.params.account_id
                    },
                    { root: true }
                )
            }
        })
    } else {
        checkRights(to, from, next)
    }
})

router.afterEach((to, from) => {
    //close create audience formula when user leaves one of builder pages
    if (includes(from.name, 'builder') && STATE.ui.builder.formAudience.display) {
        store.dispatch('ui/builder/closeAudienceForm', {}, { root: true })
    }
    // close transfer form when user leaves monitoring page
    if (from.name?.includes('monitoring')) {
        store.commit('ui/transfers/setDefaultTransferForm', {}, { root: true })
    }
    // close export form when leaving onboarding cclone
    if (from.name === 'on-boarding-cclone') {
        store.commit(
            'exports/setExportForm',
            {
                display: false,
                type: ''
            },
            { root: true }
        )
    }
    // when leaving taxo, clear store (selectedType && taxo list)
    if (from.name === 'on-boarding-manage-taxonomy') {
        store.commit('ui/manageTaxonomy/setRetrievedItems', { id: STATE.ui.manageTaxonomy.selectedTaxoId, items: [] }, { root: true })
        setTimeout(store.commit('ui/manageTaxonomy/setIsLoading', { item: 'taxonomy', isLoading: false }, { root: true }), 500)
    }
    if (to.name === 'on-boarding-manage-taxonomy') {
        // update manageTaxo store before arriving on page (selectedType && taxo list if not already in store)
        const taxoIds = map(STATE.data.customTaxonomies.customTaxonomies, taxo => taxo.id)
        if (!isEmpty(taxoIds)) {
            if (isNil(STATE.ui.manageTaxonomy.selectedTaxoId)) store.commit('ui/manageTaxonomy/setSelectedTaxoId', { id: taxoIds[0] }, { root: true })
            if (!isNil(STATE.account.accountId) && isEmpty(get(STATE.ui.manageTaxonomy.taxonomies, `${taxoIds[0]}`, []))) {
                store.dispatch('ui/manageTaxonomy/retrieveHierarchyOfSelectedTaxonomy', { taxoId: STATE.ui.manageTaxonomy.selectedTaxoId }, { root: true })
            }
        }
    }

    if (from.name === 'forbidden') {
        store.dispatch('account/retrieveItems', {}, { root: true })
    }
})

export default router
